import { Inject, Injectable, Output, EventEmitter } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { AdalService } from '../shared/azure-authentication/adal.service';
import { BaseEndpoint } from '../app.constants';
import { Role } from './role.model';

@Injectable()
export class RoleService {
    private roles: Role[] = [];
    @Output() requestAdded: EventEmitter<any[]> = new EventEmitter<any[]>();

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiUrl, private adalService: AdalService) {
    }

    getRoles(): Promise<Role[]> {
        var url = this.baseApiUrl + 'v1/roles';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                this.roles = resp.json().body as Role[];
                return this.roles;
            })
            .catch(this.handleError);
    }

    getRolesCache(): Promise<Role[]> {
        if (this.roles.length == 0) {
            return this.getRoles();
        }
        else {
            var promise = new Promise<Role[]>((resolve, reject) => {
                resolve(this.roles);
            });
            return promise;
        }
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}




// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/roles/role.service.ts